module.exports = __webpack_public_path__ + "img/45.98391339.svg";